<template>
<div class="menu-container container">

  <!-- Mobile menu -->
  <div class="menu" :class="[menuOpenClass, { 'is-transitioning' : menu.isTransitioning }]" @transitionend="menu.isTransitioning = false">
    <div class="menu__inner" :class="menuOpenClass">
      <router-link
        v-for="link in links"
        :key="link.path"
        :to="link.path"
        class="menu__link"
        :class="[menuOpenClass, pathIsRootClass]"
      >
        {{ link.text }}<sup v-if="link.path === '/work'" class="menu__work-count">({{ projects.length }})</sup>
      </router-link>
    </div>
  </div>
  <!-- / Mobile menu -->

  <!-- Logo -->
  <router-link
    @click.native="closeMenu"
    to="/"
    class="menu__logo"
    :class="[menuOpenClass, { 'is-black' : !pathIsRoot}]">
    Thank You For Clapping
  </router-link>
  <!-- /Logo -->

  <div class="menu__links">
    <!-- Primary links -->
    <router-link
      v-for="link in links"
      :key="link.path"
      class="menu__item"
      :class="[menuItemClass]"
      :to="link.path === $route.path ? '/' : link.path"
    >
      {{ link.text }}<sup v-if="link.path === '/work'" class="menu__work-count">({{ projects.length }})</sup>
    </router-link>
    <!-- /Primary links -->
  </div>

  <button
    @click="toggleMenu"
    class="menu__button hamburger hover"
    :class="[menuOpenClass, { 'is-black' : !pathIsRoot}]">
    <span class="hamburger__inner"></span>
  </button>

</div>
</template>

<script>
import store from '../store'
import projects from '../projects'

export default {
  name: 'main-menu',
  data () {
    return {
      projects: projects,
      contact: store.contact,
      links: [
        // {
        //  text: 'About',
        //  path: '/about'
        // },
        {
          text: 'Contact',
          path: '/contact'
        }
        // ,{
        //   text: 'Work',
        //   path: '/work'
        // }
      ],
      menu: {
        open: false,
        isTransitioning: false
      }
    }
  },
  computed: {
    pathIsRoot () {
      return this.$route.path === '/'
    },
    pathIsRootClass () {
      return {
        'path-root': this.pathIsRoot
      }
    },
    menuOpenClass () {
      return { 'menu-open': this.menu.open }
    },
    menuItemClass () {
      return { 'is-black': !this.pathIsRoot }
    }
  },
  watch: {
    '$route': function () {
      this.menu.isTransitioning = true
      this.menu.open = false
    }
  },
  methods: {
    toggleMenu () {
      this.menu.isTransitioning = true
      this.menu.open = !this.menu.open
    },
    closeMenu () {
      this.menu.isTransitioning = true
      this.menu.open = false
    }
  }
}
</script>

<style lang="sass" scoped>

@import "../assets/sass/utilities/variables"
@import "../assets/sass/utilities/mixins"

.menu-container
  position: fixed
  top: 0
  left: 0
  right: 0
  display: flex
  justify-content: space-between
  flex-direction: row
  padding-top: 4.5vw
  z-index: 1000

.menu__button
  position: relative
  width: 20px
  height: 20px
  z-index: 1
  background-color: transparent
  border: none
  -webkit-tap-highlight-color: rgba(255,255,255,0)
  &::after
    content: ''
    width: 50px
    height: 50px
    position: absolute
    top: -16px
    left: -6px
  +medium
    align-self: center

.menu
  position: fixed
  top: 0
  right: 0
  bottom: 0
  left: 0
  background: $white
  transform: translateY(-100%)
  will-change: transform
  &.is-transitioning
    transition: transform 300ms ease-in-out
    +small
      transition-duration: 333ms
  +medium
    display: none
  &.menu-open
    transform: none

.menu__inner
  position: fixed
  left: 50%
  top: 50%
  display: flex
  flex-direction: column
  text-align: center
  transform: translate(-50%, -50%)

.menu__work-count
  position: absolute
  font-size: 0.5em
  top: -0.2em
  right: -0.3em
  +medium
    top: -0.4em
    right: -1.5em

.menu__item
  color: $white
  font-weight: 500
  text-decoration: none
  font-size: 0.8rem
  display: none
  cursor: pointer
  margin-left: 1rem
  border-bottom: 1px solid rgba(255,255,255,0)
  transition: border-bottom-color 0.5s ease-out, color 0.5s ease-out
  line-height: 1.5
  &.is-black
    color: $black
    border-bottom-color: rgba(0,0,0,0)
    &:hover
      border-bottom-color: rgba(0,0,0,1)
    &.router-link-active
      color: $black
  &::selection
    background-color: rgba(0,0,0,0)
  &:hover
    border-bottom-color: rgba(255,255,255,1)
  &.router-link-active
    font-weight: 500
    border-bottom-color: rgba(0,0,0,1)
  &--secondary
    margin-top: 0
    margin-bottom: 0.67rem
  +medium
    display: block

.menu__links
  position: relative
  display: flex
  margin-left: auto
  margin-right: $column-gap

.menu__link
  position: relative
  font-size: 2rem
  text-decoration: none
  font-weight: 500
  font-size: 2rem
  transition-duration: 0.5s
  color: #cacaca
  margin: 0.75rem 0
  &:hover
    opacity: 0.3
  &.router-link-active
    font-weight: 700
    color: $black
  &.path-root
    color: $black
    font-weight: 500

.menu__logo
  transition: color 0.5s, opacity 0.5s
  font-weight: 500
  color: $white
  +medium
    margin-bottom: auto
    margin-right: auto
  &.is-black, &.menu-open
    color: $black

.hamburger
  padding: 0
  width: 23px
  height: 21px
  font-size: 0
  text-indent: -9999px
  appearance: none
  box-shadow: none
  border-radius: none
  border: none
  cursor: pointer
  transition: background 0.1s, opacity 0.2s
  +medium
    display: none

.hamburger:focus
  outline: none

.hamburger:hover
  opacity: 0.5s

.hamburger__inner
  display: block
  position: absolute
  top: 10px
  left: 0
  right: 0
  height: 2px
  background: $white
  transition: background 0s 0.1s

.hamburger__inner::before,
.hamburger__inner::after
  position: absolute
  display: block
  left: 0
  width: 100%
  height: 2px
  background-color: $white
  content: ""
  transition-duration: 0.1s, 0.1s
  transition-delay: 0.1s, 0s
  +medium
    background-color: $black

.hamburger__inner::before
  transition-property: top, transform
  top: -7px

.hamburger__inner::after
  transition-property: bottom, transform
  bottom: -7px

.hamburger.is-black .hamburger__inner,
.hamburger.menu-open .hamburger__inner
  background-color: $black
  &::before, &::after
    background-color: $black

.hamburger.menu-open
  & .hamburger__inner
    background: none
    &::before, &::after
      transition-delay: 0s, 0.1s

    &::before
      top: 0
      transform: rotate(45deg)

    &::after
      bottom: 0
      transform: rotate(-45deg)

</style>



// WEBPACK FOOTER //
// MainMenu.vue?dc0faec4